<template>
  <div class="mb-12 flex gap-12">
    <span v-for="task in tasks" :key="task.id">
      <TaskStatus
        :data-test="`task-status-${task.type}`"
        :deadline="task.deadline"
        :status="task.status"
        :task-type="task.type"
      />
    </span>
    <TaskStatus
      v-if="tasks.length == 0 && requestStatus"
      data-test="request-status"
      :status="requestStatus"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  OrderlineOpenTask,
  OrderlineRequest,
} from '~/api/seller-after-sales/types'
import TaskStatus from '~/scopes/customer-care/components/TaskStatus/TaskStatus.vue'
import { getAllTasks } from '~/scopes/customer-care/components/request.helpers'

const { requests } = defineProps<{
  requests: OrderlineRequest[]
}>()

const tasks = computed(() => {
  const allTasks = getAllTasks(requests)

  const openTasks = allTasks.filter((task) => task.status === 'OPEN')
  const orderedOpenTaskTask = openTasks.sort(
    (a, b) => Date.parse(a.deadline) - Date.parse(b.deadline),
  )

  const noDuplicateOpenTasks = orderedOpenTaskTask.reduce(
    (uniqueTasks: OrderlineOpenTask[], currentTask: OrderlineOpenTask) => {
      return uniqueTasks.some((t) => t.type === currentTask.type)
        ? uniqueTasks
        : [...uniqueTasks, currentTask]
    },
    [],
  )

  if (noDuplicateOpenTasks.length) {
    return noDuplicateOpenTasks
  }

  const upcomingTasks = allTasks.filter((task) => task.status === 'UPCOMING')

  return upcomingTasks
})

const requestStatus = computed(() => {
  const noActionNeededRequest = requests.find(
    (request) => request.status === 'NO_ACTION_NEEDED',
  )
  if (noActionNeededRequest) {
    return 'NO_ACTION_NEEDED'
  }

  const completedRequest = requests.find(
    (request) => request.status === 'COMPLETED',
  )
  if (completedRequest) {
    return 'COMPLETED'
  }

  return null
})
</script>
